<template>
	<section class="courses-thumbnail-section">
		<h2 class="courses-thumbnail-section__title">{{ $t('my_courses') }}</h2>
		<template v-if="selection.length">
			<ul class="courses-thumbnail-section__list">
				<li v-for="course in selection">
					<article class="course-thumbnail">
						<div class="course-thumbnail__scale" :style="`width: ${course.result}%;`"></div>
						<a :href="course.url" class="course-thumbnail__link" :title="course.name">
							<h3 class="course-thumbnail__title">{{ course.name }}</h3>
							<div class="course-thumbnail__value">{{ course.result }}%</div>
						</a>
					</article>
				</li>
			</ul>
			<div class="courses-thumbnail-section__bottom">
				<a href="/my_active_courses" class="app-btn app-btn--primary app-btn--round app-btn--arrow-up">{{ $t('buttons.all_my_courses')}}</a>
			</div>
		</template>
		<template v-else>
			<div class="courses-thumbnail-section__message-holder">
				<p class="courses-thumbnail-section__message">
					{{ $t('messages.start_your_learning_path') }}
				</p>
			</div>
		</template>
	</section>
</template>
<script>

export default {
	name: "MyActiveCourses",

	props: {
		selection: Array
	},

	data() {
		return {

		};
	},

	methods: {

	}
};
</script>
